import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * TabFilter Component
 * 
 * @param {Array} tabs - Array of tab objects
 *   Example: [
 *     { label: 'All Users', value: 'all' },
 *     { label: 'Viewers', value: 'viewers' },
 *     { label: 'Artists', value: 'artists' }
 *   ]
 * 
 * @param {String} activeTab - Currently active tab value
 * @param {Function} onTabChange - Callback function when tab changes
 */

const TabFilter = ({ tabs = [], activeTab, onTabChange }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                gap: 1,
                flexWrap: 'wrap',
            }}
        >
            {tabs.map((tab) => (
                <Button
                    key={tab.value}
                    onClick={() => onTabChange(tab.value)}
                    sx={{
                        px: 3,
                        py: 1,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 500,
                        backgroundColor:
                            activeTab === tab.value
                                ? theme.palette.primary.main
                                : 'rgba(255, 255, 255, 0.05)',
                        color:
                            activeTab === tab.value
                                ? theme.palette.blackColor.black1
                                : theme.palette.text.secondary,
                        border:
                            activeTab === tab.value
                                ? 'none'
                                : '1px solid rgba(255, 255, 255, 0.1)',
                        '&:hover': {
                            backgroundColor:
                                activeTab === tab.value
                                    ? theme.palette.primary.dark
                                    : 'rgba(255, 255, 255, 0.1)',
                        },
                    }}
                >
                    {tab.label}
                </Button>
            ))}
        </Box>
    );
};

export default TabFilter;